import React, { useState, useEffect, useMemo } from 'react';
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import "dayjs/locale/ja";

dayjs.locale("ja");

export default function InspectionDate({ label, field, checkSummary, updateCheckSummary, handleChange }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [validationError, setValidationError] = useState(null);

  const errorMessage = useMemo(() => {
    switch (validationError) {
      case 'invalidDate': {
        return '有効な日時形式で入力してください。';
      }
      case 'required': {
        return '必ず入力してください。';
      }
      default: {
        // エラーがない、または未定義のエラーの場合
        return '';
      }
    }
  }, [validationError]);

  useEffect(() => {
    if (checkSummary?.[field]) {
      const parsed = dayjs(checkSummary[field]);
      setSelectedDate(parsed);
      updateCheckSummary(field, parsed.format("YYYY/MM/DD"))
    } else {
    if (field == "previous_at") {
      setValidationError("required");
    }
    }
  }, []);

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    handleChange({ target: { value: newValue ? newValue.format("YYYY/MM/DD") : "" } });
    if (!newValue) {
      setValidationError("required")
    } else {
      setValidationError(null)
    }
  };

  const handleDateError = (newError) => {
    if (newError === "invalidDate") {
      setValidationError("invalidDate");
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={checkSummary?.[field] ? dayjs(checkSummary[field]) : null}
        onChange={handleDateChange}
        onError={handleDateError}
        format="YYYY年MM月DD日"
        slotProps={{
          textField: {
              error: !!validationError,
              helperText: errorMessage,
              margin: "dense",
          },
      }}
      />
    </LocalizationProvider>
  );
}
